import { cn } from '../../lib/utils'
import { formatSecretTimestamp } from './secret-dashboard-utils'
import type { SecretAuditEvent } from '../../hooks/use-secrets'

interface SecretAuditPanelProps {
  events: SecretAuditEvent[]
  isDark: boolean
}

function eventLabel(event: SecretAuditEvent): string {
  return String(event.action ?? event.resourceType ?? 'audit.event')
}

export function SecretAuditPanel({ events, isDark }: SecretAuditPanelProps) {
  return (
    <section>
      <div className="mb-2 text-sm font-medium">Audit</div>
      {events.length === 0 ? (
        <p className="text-xs text-neutral-500">No matching audit events.</p>
      ) : (
        <div className="space-y-1">
          {events.slice(0, 10).map((event, index) => (
            <div key={String(event.id ?? index)} className={cn('rounded-md px-2 py-1.5 text-xs', isDark ? 'bg-surface-2 text-neutral-400' : 'bg-neutral-100 text-neutral-600')}>
              <div className="font-medium">{eventLabel(event)}</div>
              <div>{formatSecretTimestamp(event.createdAt)}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
